"use client"

import { Share } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShareIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShareIcon = component(Icon)({ as: Share })
